export default __webpack_public_path__ + "230c808247fb8e758db4743ebe55ed39.svg";